"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var invariant_1 = tslib_1.__importDefault(require("invariant"));

var registered = [];

function create(schema) {
  // There's no need for an extra wrapper.
  if (isBridge(schema)) {
    return schema;
  }

  var Bridge = registered.find(function (bridge) {
    return bridge.check(schema);
  });
  invariant_1.default(Bridge, 'Unrecognised schema: %s', schema);
  return new Bridge(schema);
}

function isBridge(schema) {
  return !!(schema && schema.getError && schema.getErrorMessage && schema.getErrorMessages && schema.getField && schema.getInitialValue && schema.getProps && schema.getSubfields && schema.getType && schema.getValidator);
}

function register(bridge) {
  registered.unshift(bridge);
}

exports.default = Object.assign(create, {
  register: register,
  registered: registered
});